if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.MS_IN_SEC = 1000;
        this.MS_IN_MIN = 60 * this.MS_IN_SEC;
        this.MS_IN_HRS = 60 * this.MS_IN_MIN;
        this.MS_IN_DAY = 24 * this.MS_IN_HRS;

        this.shouldAddLeadingZero = true;
        this.type = this.dataset.type;
        // PRINTED TAPE (2 Oct 2026): printed gummed tape is on an 11-18 business
        // day slot with no Priority option, so the free-upgrade countdown must
        // never show on the tape product page. The element keeps its 'hidden'
        // class because beginCountdown() is never reached. Original file kept
        // as assets/countdown-timer-backup-2026-10-02.js.
        if (window.location.pathname.indexOf('gummed-tape') > -1) return;
        this.initCountdown();
      }

      initCountdown() {
        switch (this.type) {
          case 'fixed_time':
            const countdownData = this.dataset.dueDate;
            if (countdownData) {
              this.targetTime = new Date(countdownData).getTime();
            }
            break;
          default: // Evergreen.
            this.targetTime = this.getEvergreenDueDate().getTime();
            break;
        }

        if (!this.targetTime) return;

        this.startTime = Date.now();
        if (this.targetTime > this.startTime) {
          this.beginCountdown();
        }
      }

      beginCountdown() {
        this.intervalId = setInterval(() => {
          const remainingTime = this.targetTime - Date.now();
          if (remainingTime <= 0) {
            this.terminateCountdown();
          } else {
            this.updateDisplay(remainingTime);
          }
        }, 1000);
        this.classList.remove('hidden');
      }

      updateDisplay(remainingTime) {
        const days = Math.floor(remainingTime / this.MS_IN_DAY);
        const hours = Math.floor((remainingTime % this.MS_IN_DAY) / this.MS_IN_HRS);
        const minutes = Math.floor((remainingTime % this.MS_IN_HRS) / this.MS_IN_MIN);

        const h = this.shouldAddLeadingZero && hours < 10 ? `0${hours}` : hours;
        const m = this.shouldAddLeadingZero && minutes < 10 ? `0${minutes}` : minutes;
        const d = days > 0 ? `${days} ${days === 1 ? 'day' : 'days'} ` : '';

        this.innerHTML = `⚡ Order today and you could unlock a free delivery upgrade at checkout 🚚 Offer ends in<span class="purpletext"> ${d}${h} hrs ${m} mins</span> ⏰`;
      }

      terminateCountdown() {
        clearInterval(this.intervalId);
        this.targetTime = this.getEvergreenDueDate().getTime();
        this.beginCountdown();
      }

      // Offer cut-off is 5pm on a working day. Mirrors the logic in
      // sections/exit-intent-upgrade.liquid and sections/cart-upgrade-countdown.liquid
      // so the product page, the pop-up and the cart all agree. Weekends are
      // skipped: after 5pm on a Friday this rolls to 5pm on Monday, not Saturday.
      //
      // RE-ENABLED 21 September 2026 when the promotion was restarted. Between 14
      // and 21 Sep this showed the 12:00 midday despatch message instead.
      // This countdown only renders on PRINTED product pages, which is why 5pm
      // (the offer deadline) is the right target here rather than the 3pm
      // unprinted next-working-day cut-off. Confirmed by Corey 15 Sep 2026.
      isWorkingDay(date) {
        const day = date.getDay();
        return day >= 1 && day <= 5;
      }

      getEvergreenDueDate() {
        const now = new Date();
        const dueDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0, 0);
        while (dueDate.getTime() <= now.getTime() || !this.isWorkingDay(dueDate)) {
          dueDate.setDate(dueDate.getDate() + 1);
          dueDate.setHours(17, 0, 0, 0);
        }
        return dueDate;
      }
    }
  );
}
